'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectGlobalStyle = undefined;

var _templateObject = _taggedTemplateLiteral(['    \n    html,\n    body {\n      font-size: 100%;\n      display: flex;\n      align-items: stretch;\n      overflow-x: hidden;\n    }\n    \n    body {\n      cursor: default;\n      background-color: ', ';\n      color: ', ';\n      font-family: ', ';\n      font-weight: ', ';\n      line-height: ', ';\n      position: relative;\n      width: 100%;\n      display: flex;\n      min-height: 100vh;\n      flex-direction: column;\n    }\n  '], ['    \n    html,\n    body {\n      font-size: 100%;\n      display: flex;\n      align-items: stretch;\n      overflow-x: hidden;\n    }\n    \n    body {\n      cursor: default;\n      background-color: ', ';\n      color: ', ';\n      font-family: ', ';\n      font-weight: ', ';\n      line-height: ', ';\n      position: relative;\n      width: 100%;\n      display: flex;\n      min-height: 100vh;\n      flex-direction: column;\n    }\n  ']);

var _styledComponents = require('styled-components');

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var injectGlobalStyle = exports.injectGlobalStyle = function injectGlobalStyle() {
  // eslint-disable-next-line no-unused-expressions
  (0, _styledComponents.injectGlobal)(_templateObject, _base2.default.body.backgroundColor, _base2.default.body.fontColor, _base2.default.fontFamily[_base2.default.body.fontFamily], _base2.default.body.fontWeight, _base2.default.body.lineHeight);
};